import {
  type StaffingLevel,
  type StaffingLevelData,
} from 'domains/shifts/components/components/staffing-levels/utils/types'
import { AllocationType, ShiftType } from 'domains/shifts/components/types'

const allocationShiftTypes = [ShiftType.Running, ShiftType.Picking]

/**
 * Returns staffing levels for a specific shift type,
 * and optionally, allocation type
 */
export const getStaffingLevelsForShiftType: (
  staffingLevels: StaffingLevel[],
  shiftType: ShiftType,
  allocationType?: AllocationType
) => StaffingLevelData[] = (staffingLevels, shiftType, allocationType) => {
  if (
    allocationShiftTypes.find(allocationShiftType => shiftType === allocationShiftType) ===
    undefined
  ) {
    return staffingLevels.map(l => l[shiftType])
  }

  if (allocationType) {
    return staffingLevels.map(l => l[shiftType][allocationType])
  }

  // If an allocationType wasn't provided for Picking shifts,
  // we aggregate the dedicated and on call levels to return a single value
  return staffingLevels.map(l => {
    const dedicated = l[shiftType][AllocationType.Dedicated]
    const oncall = l[shiftType][AllocationType.OnCall]

    return {
      scheduled: dedicated.scheduled + oncall.scheduled,
      required: dedicated.required + oncall.required,
      closed: dedicated.closed,
    }
  })
}
